import { nextTick, ref } from 'vue';
import { isAxiosError } from 'axios';
import { focusInvalidField, jsonApiSpecErrorsToLaravel } from '../utils/validation';
import { useToasted } from './useToasted';
import { catchRequestError } from '~/utils/request';

export function useFormRequestHandler() {
    const toasted = useToasted();
    const $externalResults = ref<Record<string, string[]>>({});

    const catchError = async (error: unknown) => {
        if (!isAxiosError(error) || error.response?.status !== 422) {
            toasted.error(catchRequestError(error), {
                sticky: true,
            });
            $externalResults.value = {};
            return;
        }

        console.error(error);

        const errors = error.response.data.errors;

        if (Array.isArray(errors)) {
            $externalResults.value = jsonApiSpecErrorsToLaravel(errors);
        } else {
            $externalResults.value = errors;
        }

        await nextTick();
        const hasInvalidField: boolean = focusInvalidField();
        if (!hasInvalidField) {
            toasted.error(catchRequestError(error, false), {
                sticky: true,
            });
        }
    };

    return {
        $externalResults,
        catchError,
    };
}
